import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";

import { Button, TextFieldInput } from "@smart/itops-sb-design-system-dom";
import { displayName } from "@smart/itops-utils-basic";

import { LoginParams, loginSchema } from "../hooks";

export type UsernamePasswordProps = {
  initial?: Partial<LoginParams>;
  onLogin: (params: LoginParams) => void;
};

export const UsernamePassword = ({
  onLogin,
  initial,
}: UsernamePasswordProps) => {
  const { register, handleSubmit } = useForm({
    resolver: zodResolver(loginSchema),
    defaultValues: { username: "", password: "", ...initial },
  });

  return (
    <form
      className="relative my-[1rem] max-w-[80rem] w-[98%] flex flex-col gap-small"
      onSubmit={handleSubmit(onLogin)}
    >
      <TextFieldInput
        id="username"
        label="Email"
        {...register("username")}
        inputMode="email"
        autoFocus
      />
      <TextFieldInput
        id="password"
        label="Password"
        {...register("password")}
        type="password"
      />
      <div className="flex justify-start">
        <Button type="submit" text={`Sign In To ${displayName}`} />
      </div>
    </form>
  );
};
